__turbopack_context__.v({
  "community-map": "CommunityMap-module-scss-module__QweMXG__community-map",
  "marker": "CommunityMap-module-scss-module__QweMXG__marker",
  "text": "CommunityMap-module-scss-module__QweMXG__text",
});
